import { SVGProps } from 'react';

const UndoDot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 17a9 9 0 0 0-15-6.7L3 13m6 0H3V7m10 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
  </svg>
);
export default UndoDot;
